import React, { useEffect, useState } from "react";

import { useTranslation } from "react-i18next";

export const LoadingMore: React.FC = () => {
  const { t: translate } = useTranslation();

  const sentences = [`${translate("loading")}`, `${translate("loading")}`];

  const [dots, setDots] = useState("");
  const [currentSentence, setCurrentSentence] = useState(sentences[0]);

  useEffect(() => {
    const dotInterval = setInterval(() => {
      setDots((prevDots) => (prevDots.length === 3 ? "" : `${prevDots}.`));
    }, 500);

    return () => {
      clearInterval(dotInterval);
    };
  }, []);

  useEffect(() => {
    if (dots === "") {
      setCurrentSentence((prev) => {
        const nextIndex = (sentences.indexOf(prev) + 1) % sentences.length;

        return sentences[nextIndex];
      });
    }
  }, [dots]);

  return (
    <React.Fragment>
      {currentSentence}
      {dots}
    </React.Fragment>
  );
};
